const Home = () => import('@/pages/core/home/home.vue');
const Impressum = () => import('@/pages/core/impressum/impressum.vue');
const Agb = () => import('@/pages/core/agb/agb.vue');
const Datenschutz = () => import('@/pages/core/datenschutz/datenschutz.vue');
const AboutUs = () => import('@/pages/core/about-us/about-us.vue');
const Error = () => import('@/pages/core/error/error.vue');
const Rating = () => import('@/pages/rating/rating.vue');

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      layout: 'home-layout',
    },
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum,
    meta: {
      layout: 'info-layout',
    },
  },
  {
    path: '/agb',
    name: 'AGB',
    component: Agb,
    meta: {
      layout: 'info-layout',
    },
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: Datenschutz,
    meta: {
      layout: 'info-layout',
    },
  },
  {
    path: '/ueberuns',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      layout: 'info-layout',
    },
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Error,
    meta: { error403: true },
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: Error,
    meta: { error404: true },
  },
  {
    path: '/bewertung/:activationKey',
    name: 'Rating',
    component: Rating,
    meta: {
      layout: 'rating-layout',
    },
  },
];
